import type { JSX } from 'react';

import { Link } from '@change/ds-core-ui';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { CardCarousel } from './components/CardCarousel';
import { QRPosterCard } from './components/QRPoster/components/QRPosterCard/variant2';
import { SocialContentCard } from './components/SocialContent/components/SocialContentCard/variant2';

export function Variant2(): JSX.Element {
	const {
		data: {
			petition: { slug },
		},
	} = useStarterDashboardV2PageData();
	const items = [
		{
			key: 'social-content',
			component: <SocialContentCard />,
		},
		{
			key: 'qr-poster',
			component: <QRPosterCard />,
		},
	];
	return (
		<div className="flex w-full flex-col gap-5 overflow-x-visible py-8 md:px-12 md:py-12">
			<div className="flex flex-row items-center justify-between px-4 md:px-0">
				<Text variant="heading" size="small">
					<Translate value="corgi.petition.starter_dashboard_v2.sharing_tools.title" />
				</Text>
				<Link data-qa="all-tools-link" href={`/p/${slug}/dashboard/share`} variant="primary">
					<Text className="font-bold" variant="body" size="medium">
						<Translate value="corgi.petition.starter_dashboard_v2.sharing_tools.all_tools" />
					</Text>
				</Link>
			</div>
			<CardCarousel items={items} />
		</div>
	);
}
